import React from 'react';
import { AvatarSizeTokens, ColorTokens, DividerSizeTokens, FontTransformToken, IconSizeTokens, IconTokens, SizeTypeTokens, StackAlignItems, StackJustifyContent, StackType, TypographyTypeTokens, } from '@voltmoney/schema';
import { View } from 'react-native';
import Card from '../card/Card';
import Stack from '../stack/Stack';
import Typography from '../typography/Typography';
import Space from '../space/Space';
import Avatar from '../avatar/Avatar';
import Icon from '../icon/Icon';
import Divider from '../divider/Divider';
const UserCard = ({ title, title_secondary, subtitle, avatar, location, onPress, action, padding = { top: SizeTypeTokens.LG }, triggerAction, }) => {
    // if (!title) return <></>;
    const handleAction = () => {
        onPress && onPress();
        action &&
            triggerAction &&
            triggerAction(action);
    };
    return (React.createElement(Card, { onPress: handleAction, padding: padding, header: {
            children: (React.createElement(Stack, { type: StackType.row, alignItems: StackAlignItems.center },
                React.createElement(Avatar, { uri: avatar, size: AvatarSizeTokens.MD }),
                React.createElement(Space, { size: SizeTypeTokens.MD }),
                React.createElement(View, { style: {
                        flex: 1,
                    } },
                    React.createElement(Stack, { type: StackType.row, alignItems: StackAlignItems.center, justifyContent: StackJustifyContent.spaceBetween },
                        React.createElement(View, { style: { flex: 1 } },
                            React.createElement(Typography, { label: title, numberOfLines: 1, textTransform: FontTransformToken.capitalize, type: TypographyTypeTokens.S5 })),
                        title_secondary ? (React.createElement(Typography, { label: title_secondary, type: TypographyTypeTokens.B7, color: ColorTokens.Grey_200 })) : (React.createElement(React.Fragment, null))),
                    React.createElement(Space, { size: SizeTypeTokens.SM }),
                    location ? (React.createElement(Stack, { type: StackType.row, alignItems: StackAlignItems.center },
                        React.createElement(Icon, { name: IconTokens.LocationPin, size: IconSizeTokens.XS, color: ColorTokens.Grey_200 }),
                        React.createElement(Space, { size: SizeTypeTokens.SM }),
                        React.createElement(Typography, { label: location, type: TypographyTypeTokens.B6, color: ColorTokens.Grey_200 }))) : (React.createElement(Typography, { label: subtitle, numberOfLines: 1, type: TypographyTypeTokens.B6, color: ColorTokens.Grey_200 }))))),
        }, footer: {
            children: !title_secondary ? ([
                React.createElement(Space, { size: SizeTypeTokens.LG }),
                React.createElement(Divider, { size: DividerSizeTokens.SM }),
            ]) : (React.createElement(React.Fragment, null)),
        } }));
};
export default React.memo(UserCard);
export { UserCard };
